import { useNftx, useTransaction } from '@nftx/react';
import useInfrastructure from '../../useInfrastructure';
import { useSettings } from '@/presentation/context/settings';

const useLpClaimRewards = () => {
  const { network, provider, signer } = useNftx();
  const {
    positions: { claimLpRewards },
  } = useInfrastructure();
  const [settings] = useSettings();
  const slippagePercentage = Number(settings.slippage);

  type Args = Omit<
    Parameters<typeof claimLpRewards>[0],
    'network' | 'provider' | 'signer' | 'slippagePercentage'
  >;

  return useTransaction((args: Args) => {
    return claimLpRewards({
      ...args,
      provider,
      signer,
      network,
      slippagePercentage,
    });
  });
};

export default useLpClaimRewards;
